<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div slot="body">
        <rate-group-answer :config="config" :model="config" :cvtLang="cvtLang" prop="value" :answerValidate="answerValidate"></rate-group-answer>
      </div>
    </answer-render>
  </div>
</template>

<script>

import answerValidate from './answerValidate'
export default {
  name: 'RateBoxAnswer',
  props: ['config', 'cvtLang'],
  data () {
    return {
      answerValidate
    }
  },
  components: {

  },
  watch: {},
  computed: {

  },
  methods: {

  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/editor/RateBox/RateBoxAnswer.vue